import { format as formatDate } from 'date-fns';

export const defaultTriggerWrapperClassName =
  'flex h-button/size w-full items-center gap-2 rounded-radius/button border border-gray-400 px-padding/x-inner-element opacity-100 text-text/primary alpha-form-input focus-within:border-2 focus-within:!border-black hover:border-border/form-hover hover:shadow-md disabled:text-gray-600 disabled:hover:shadow-none bg-buttons/base';

export const defaultTriggerButtonClassName =
  'flex w-full items-center justify-start';

export const defaultContentClassName =
  'z-[--z-index-dropdown] border border-gray-400 p-0 w-[--general-content-max-width] max-w-[--general-content-max-width] lg:w-auto lg:max-w-auto';

export const defaultPlacement = 'bottom-end' as const;

export const defaultDoneLabel = 'Done';

export const defaultPlaceholder = 'Select dates';

export const defaultFormatDate = (date: Date): string =>
  formatDate(date, 'MMM dd, yyyy');

export const defaultMonthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
] as const;

export const defaultWeekdayNames = [
  'Sun',
  'Mon',
  'Tue',
  'Wed',
  'Thu',
  'Fri',
  'Sat',
] as const;

export const mobileNavigationButtonClassName =
  'pointer-events-auto flex h-[--button-size-regular] min-h-[--button-size-regular] w-[--button-size-regular] min-w-[--button-size-regular] items-center justify-center gap-[--button-gap] rounded-full border border-[--buttons-primary] bg-[--buttons-base] px-[--button-padding-regular-x] py-0 text-[--buttons-primary] shadow-md transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary-800 disabled:cursor-not-allowed disabled:border-buttons/disable disabled:text-[--buttons-disable] disabled:shadow-none active:bg-buttons/primary-hover active:border-buttons/primary-hover active:text-text/on-dark !p-0 z-10';
